import { gql } from "@apollo/client";

export const GET_POST = gql`
  query GetPost($id: ID!, $idType: PostIdTypeEnum = SLUG) {
    post(id: $id, idType: $idType) {
      id
      title
      slug
      excerpt
      content
      date
      categories {
        nodes {
          name
          slug
        }
      }
      author {
        node {
          id
          name
          slug
          description
          avatar {
            url
          }
        }
      }
      featuredImage {
        node {
          id
          sourceUrl
          mediaDetails {
            sizes {
              name
              sourceUrl
            }
          }
        }
      }
    }
  }
`;

export const GET_POST_BY_SLUG = gql`
  query GetPostBySlug($slug: ID!) {
    post(id: $slug, idType: SLUG) {
      id
      title
      slug
      excerpt
      content
      date
      categories {
        nodes {
          name
          slug
        }
      }
      author {
        node {
          id
          name
          slug
          description
          avatar {
            url
          }
        }
      }
      featuredImage {
        node {
          id
          sourceUrl
          mediaDetails {
            sizes {
              name
              sourceUrl
            }
          }
        }
      }
    }
  }
`;
export const GET_POSTS = gql`
  query GetPosts($first: Int, $after: String, $search: String) {
    posts(first: $first, after: $after, where: { search: $search }) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        title
        excerpt
        slug
        date
        categories {
          nodes {
            name
            slug
          }
        }
        tags {
          nodes {
            name
          }
        }
        author {
          node {
            id
            name
            slug
            avatar {
              url
            }
          }
        }
        featuredImage {
          node {
            id
            sourceUrl
            mediaDetails {
              sizes {
                name
                sourceUrl
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_POSTS_WITHOUT_CAT = gql`
  query GetPosts($first: Int, $after: String, $category: [ID]) {
    posts(first: $first, after: $after, where: { categoryNotIn: $category }) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        title
        excerpt
        slug
        date
        categories {
          nodes {
            name
            slug
          }
        }
        tags {
          nodes {
            name
          }
        }
        author {
          node {
            id
            name
            slug
            avatar {
              url
            }
          }
        }
        featuredImage {
          node {
            id
            sourceUrl
            mediaDetails {
              sizes {
                name
                sourceUrl
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_POSTS_BY_SLUG = gql`
  query GetPostBySlug($first: Int, $after: String, $slug: String) {
    posts(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        title
        excerpt
        slug
        date
        categories {
          nodes {
            name
            slug
          }
        }
        tags {
          nodes {
            name
          }
        }
        author {
          node {
            id
            name
            description
            avatar {
              url
            }
          }
        }
        featuredImage {
          node {
            id
            sourceUrl
            mediaDetails {
              sizes {
                name
                sourceUrl
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_FEATURED_POST = gql`
  query GetFeaturedPost {
    posts(where: { tagSlugIn: ["featured"] }, first: 1) {
      nodes {
        id
        title
        slug
        date
        content
        categories {
          nodes {
            name
            slug
          }
        }
        tags {
          nodes {
            name
          }
        }
        featuredImage {
          node {
            id
            sourceUrl
            mediaDetails {
              sizes {
                name
                sourceUrl
              }
            }
          }
        }
        author {
          node {
            id
            name
            slug
            avatar {
              url
            }
          }
        }
      }
    }
  }
`;

export const GET_POSTS_BY_AUTHOR = gql`
  query GetPostsByAuthor($authorSlug: String!, $first: Int, $after: String) {
    posts(first: $first, after: $after, where: { authorName: $authorSlug }) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        title
        excerpt
        slug
        date
        categories {
          nodes {
            name
            slug
          }
        }
        author {
          node {
            id
            name
            slug # Add the slug here
          }
        }
        featuredImage {
          node {
            id
            sourceUrl
            mediaDetails {
              sizes {
                name
                sourceUrl
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_POSTS_BY_CATEGORY_NAME = gql`
  query GetPostsByCaterogy($category: String, $first: Int, $after: String) {
    posts(first: $first, after: $after, where: { categoryName: $category }) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        title
        excerpt
        slug
        date
        categories {
          nodes {
            name
            slug
          }
        }
        author {
          node {
            id
            name
            slug # Add the slug here
          }
        }
        featuredImage {
          node {
            id
            sourceUrl
            mediaDetails {
              sizes {
                name
                sourceUrl
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_POSTS_BY_CATEGORY_ID = gql`
  query GetPostsByCaterogy($category: Int, $first: Int, $after: String) {
    posts(first: $first, after: $after, where: { categoryId: $category }) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        title
        excerpt
        slug
        date
        categories {
          nodes {
            name
            slug
          }
        }
        author {
          node {
            id
            name
            slug # Add the slug here
          }
        }
        featuredImage {
          node {
            id
            sourceUrl
            mediaDetails {
              sizes {
                name
                sourceUrl
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_GALLERY_PHOTOS = gql`
  query GetGalleryPhotos($first: Int, $after: String) {
    galleries(first: $first, after: $after) {
      nodes {
        id
        title
        slug
        author {
          node {
            name
          }
        }
        galleryFields {
          galleryDescription
          galleryPhotos {
            nodes {
              id
              sourceUrl
              mediaDetails {
                sizes {
                  name
                  sourceUrl
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_GALLERY_PHOTO_BY_SLUG = gql`
  query GetGalleryPhoto($slug: ID!) {
    gallery(id: $slug, idType: SLUG) {
      author {
        node {
          id
          name
          slug
          description
          avatar {
            url
          }
        }
      }
      id
      title
      slug
      galleryFields {
        galleryDescription
        galleryPhotos {
          nodes {
            sizes
            sourceUrl
            mediaDetails {
              sizes {
                name
                sourceUrl
                height
                width
              }
            }
          }
        }
      }
    }
  }
`;
